import React from 'react';
import { Box, Typography } from '@mui/material';

export default function PageHeader({ title, action, variant = 'h4', mb = 3 }) {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb={mb}
      sx={{ pb: 2, borderBottom: '1px solid', borderColor: 'divider' }}
    >
      <Typography
        variant={variant}
        sx={{ fontFamily: '"Fraunces", Georgia, serif' }}
      >
        {title}
      </Typography>
      {action && <Box>{action}</Box>}
    </Box>
  );
}
